import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EMAIL_REGEX } from '../auth-constants';

export const signInForm = () => {
  return new FormGroup({
    email: new FormControl(
      { value: '', disabled: false },
      Validators.compose([
        Validators.required,
        Validators.pattern(EMAIL_REGEX),
      ]),
    ),
    password: new FormControl(
      '',
      Validators.compose([
        // Validators.minLength(5),
        Validators.required,
        //this is for the letters (both uppercase and lowercase) and numbers validation
        // Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$'),
      ]),
    ),
  });
};
